import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageHeaderService {
  private headerSubject = new BehaviorSubject<{ title: string; description: string }>({
    title: '',
    description: ''
  });

  header$ = this.headerSubject.asObservable();

  setHeader(title: string, description: string) {
    this.headerSubject.next({ title, description });
  }
  constructor() { }
}
